export default function accessIsAllowed(
  currentPermissions,
  component,
  accessLevel
) {
  if (currentPermissions.length > 0) {
    const permissionsArray = currentPermissions.filter(object => {
      return object.component.trim() === component.trim();
    });

    if (
      permissionsArray.find(object => {
        return object.accessLevel.trim() === accessLevel.trim();
      })
    ) {
      return true;
    }
    return false;
  }
}
